import React from 'react';

function TeamHeader({ teamName, totalScore, currentWeek, isOpponentView = false, opponentTeam = null }) {
    // Get ordinal suffix for ranking
    const getOrdinalSuffix = (num) => {
        const j = num % 10;
        const k = num % 100;
        if (j === 1 && k !== 11) return num + "ST";
        if (j === 2 && k !== 12) return num + "ND";
        if (j === 3 && k !== 13) return num + "RD";
        return num + "TH";
    };

    return (
        <div style={{
            textAlign: 'center',
            padding: '20px',
            backgroundColor: isOpponentView ? '#8b5a3c' : '#2c3e50',
            color: 'white',
            marginBottom: '20px'
        }}>
            {/* Show ranking for opponent teams */}
            {isOpponentView && opponentTeam?.rank && (
                <div style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#f39c12',
                    marginBottom: '10px'
                }}>
                    {getOrdinalSuffix(opponentTeam.rank)} PLACE
                </div>
            )}
            
            <h1 style={{
                margin: '0 0 10px 0',
                fontSize: '28px',
                fontWeight: 'bold'
            }}>
                {teamName || 'Team Name'}
                {isOpponentView && (
                    <span style={{
                        fontSize: '16px',
                        marginLeft: '10px',
                        color: '#f39c12'
                    }}>
                        (OPPONENT)
                    </span>
                )}
            </h1>
            
            <div style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#27ae60'
            }}>
                TOTAL SCORE: {totalScore || 0}PT
            </div>
            
            {currentWeek && (
                <div style={{
                    fontSize: '14px',
                    marginTop: '5px',
                    color: '#bdc3c7'
                }}>
                    Week {currentWeek}
                </div>
            )}
        </div>
    );
}

export default TeamHeader;